module.exports = __webpack_public_path__ + "static/aopzebrabathmain-a45e9d8ac0d51c7a203b68993ba93bbf.jpeg";